import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';
import { SubjectCards } from '../../components/NotesParts';
import SubjectPicker from '../../components/SubjectPicker';

// Admin des notes : la liste des sujets. Un clic ouvre les dissertations du sujet (recherche, ajout, modification).
export default function AdminNotes() {
  const { authFetch } = useAuth();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [newSubject, setNewSubject] = useState('');
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    authFetch('/api/admin/notes/subjects')
      .then(r => r.ok ? r.json() : Promise.reject()).then(setSubjects).catch(() => setLoadError(true));
    // eslint-disable-next-line
  }, []);

  // le nouveau sujet s'ouvre tout de suite : on y ajoute ses dissertations
  const addSubject = async (e) => {
    e.preventDefault();
    if (!newSubject.trim()) return;
    setFlash(null);
    try {
      const r = await authFetch('/api/admin/notes/subjects', { method: 'POST', body: JSON.stringify({ name: newSubject }) });
      if (!r.ok) throw new Error(await errorMessage(r));
      const s = await r.json();
      navigate(`/admin/notes/sujet/${s.id}`);
    } catch (err) { setFlash({ type: 'error', text: `Sujet non ajouté : ${err.message}` }); }
  };

  return (
    <div>
      <h1 style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>Notes</h1>
      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}
      {loadError && <div className="flash error">Impossible de charger les sujets — rechargez la page.</div>}

      <form onSubmit={addSubject} className="note-subject-pick note-new-subject">
        <input value={newSubject} onChange={e => setNewSubject(e.target.value)} placeholder="Nouveau sujet (ex. Philosophie)" maxLength={100} />
        <button className="btn" type="submit" disabled={!newSubject.trim()}>+ créer le sujet</button>
      </form>

      {subjects && subjects.length === 0 && <div className="empty-state">Créez un premier sujet (ex. Philosophie), puis ajoutez-y des dissertations.</div>}
      {subjects && subjects.length > 0 && (
        <>
          <p className="qcm-intro-line" style={{ margin: '0 0 1.5rem' }}>Choisissez un sujet pour voir, chercher, ajouter ou modifier ses dissertations.</p>
          <SubjectPicker subjects={subjects.map(s => ({ id: s.id, name: s.name, count: s.count != null ? s.count : s.note_count }))} allHref="/admin/notes" hrefFor={id => `/admin/notes/sujet/${id}`} unit="diss." />
          <SubjectCards subjects={subjects} base="/admin/notes" />
        </>
      )}
    </div>
  );
}
